import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Panel from "./pages/panel/panel";
import Login from "./pages/login/login";
import Agregar from "./pages/agregar/agregar";
import ReporteTour from "./pages/reporteTour/reporteTour";
import GenerarReporte from "./pages/generarReporte/generarReporte";
import ProtectedRoute from "./componets/routes/protectedRoute"
import reportWebVitals from './reportWebVitals';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import { SnackbarProvider } from 'notistack';
import {Provider} from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Notifier from './componets/notifier/notifier';
import BackdropComponent from "./componets/backdrop/backdrop";
import {LayoutMain} from "./componets/layout/layout"
import store,{persistor} from '../src/store/store'

const router = createBrowserRouter([
    {
        path: "/",
        element: <ProtectedRoute><LayoutMain><Panel /></LayoutMain></ProtectedRoute>,
    },
    {
        path: "/login",
        element: <ProtectedRoute><Login /></ProtectedRoute>,
    },
    {
        path: "/agregar-vehiculo",
        element: <ProtectedRoute><LayoutMain><Agregar /></LayoutMain></ProtectedRoute>,
    },
    {
        path: "/operacion-tour",
        element: <ProtectedRoute><LayoutMain><ReporteTour/></LayoutMain></ProtectedRoute>,
    },
    {
        path: "/exportar-reportes",
        element: <ProtectedRoute><LayoutMain><GenerarReporte/></LayoutMain></ProtectedRoute>,
    },
]);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <Provider store={store}>
          <PersistGate persistor={persistor}>
      <SnackbarProvider
          maxSnack={1}
      >
          <Notifier></Notifier>
          <BackdropComponent/>
      <RouterProvider router={router}/>
      </SnackbarProvider>
          </PersistGate>
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
